"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapOmrReads = void 0;
var utils_1 = require("../../utils");
var omrReadForTimingCategory = function (register, omrRegisters) {
    var _a, _b;
    var matchedRegister = omrRegisters.filter(function (omrRegister) {
        return (0, utils_1.timingCategoryToTimeOfUseLabel)(omrRegister.timingCategory) ===
            register.timeOfUseLabel;
    });
    return Number((_b = (_a = matchedRegister[0]) === null || _a === void 0 ? void 0 : _a.readValue) !== null && _b !== void 0 ? _b : '0');
};
var mapOmrReads = function (omrData, sprn, meter) {
    return omrData
        .filter(function (asp) { return asp.supplyPoint.sprn === sprn; })
        .flatMap(function (asp) {
        return asp.openingMeterReads.map(function (omr) { return ({
            sprn: sprn,
            fuel: asp.supplyPoint.fuelType === 'ELECTRICITY' ? 'electricity' : 'gas',
            msn: meter.msn,
            readingType: 'OpeningReadingActual',
            formattedReadingDate: new Date(omr.readDate),
            tiers: meter.registers.map(function (register) { return ({
                meterRegisterReading: omrReadForTimingCategory(register, omr.registerReads),
                timeOfUseLabel: register.timeOfUseLabel,
                registerId: register.registerId,
            }); }),
        }); });
    });
};
exports.mapOmrReads = mapOmrReads;
